import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Description,
  Header,
  HeaderContainer,
  InnerText,
  NoTopic,
  QuestionsWrapper,
  SingleQuestionBlock,
  Title,
  Wrapper,
} from './EffectOpenCommentsTemplate.styles';
import QuestionsPaginator from './QuestionsPaginator/QuestionsPaginator';
import { convertTypeString } from '../../../../helpers/helpers';
import { OpenQuestionsAnalysis, OpenQuestionsFieldsType } from '../../../../services/reports';

interface EffectOpenCommentsTemplateProps {
  analysis: OpenQuestionsAnalysis;
  data: OpenQuestionsFieldsType[];
}

const EffectOpenCommentsTemplate: React.FC<EffectOpenCommentsTemplateProps> = ({
  analysis,
  data,
}) => {
  const { t } = useTranslation();
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);

  return (
    <>
      <HeaderContainer>
        <Header>{t(`report.effect.topics.${convertTypeString(analysis.type)}`)}</Header>
        <QuestionsPaginator data={data} onChange={setActiveQuestionIndex} />
      </HeaderContainer>

      <Wrapper>
        <Description>{analysis.description}</Description>
        <Title>{`${activeQuestionIndex + 1}. ${data[activeQuestionIndex].text}`}</Title>
        {data[activeQuestionIndex].responses.length > 0 ? (
          <QuestionsWrapper>
            {data[activeQuestionIndex].responses.map((item, index) => (
              <SingleQuestionBlock key={item.value + index}>
                <InnerText>{item.value}</InnerText>
              </SingleQuestionBlock>
            ))}
          </QuestionsWrapper>
        ) : (
          <NoTopic>{t('report.effect.topics.additional.noTopic')}</NoTopic>
        )}
      </Wrapper>
    </>
  );
};
export default EffectOpenCommentsTemplate;
